/**
 * Loan Details Service
 * Migrated from 3in1cms legacy/loanDetailsApi.ts
 */

import { request } from "../core/request";
import { API_RESPONSE_CODES, OPERATION_IDS } from "./constants";
import { logPageActionToNewRelic } from "@repo/shared-utils/newRelic-log-utils";
import { getLoginState } from "@repo/shared-utils/insert-params";
import type {
  ILoanDetail,
  ILoanDetailsRequest,
  ILoanDetailsResponse,
} from "../types/loanDetailsTypes";

/**
 * Get detailed loan information by product category
 * @param data - Loan details request
 * @returns Array of loan details filtered by product category
 */
export const getLoanDetailsList = async (data: ILoanDetailsRequest): Promise<ILoanDetail[]> => {
  try {
    const response = (await request<ILoanDetailsResponse, ILoanDetailsRequest>({
      operationId: OPERATION_IDS.loanDetails,
      requestData: { ...data },
    })) as ILoanDetailsResponse;

    if (response?.statusCode !== API_RESPONSE_CODES.STATUS_CODE_7001) {
      throw new Error(JSON.stringify(response));
    }

    let loanDetailsList: ILoanDetail[] = [];
    if (data?.prodCategory) {
      loanDetailsList = response?.loanDetailsList?.filter(
        (loan) => loan?.prodCategory === data?.prodCategory
      );
    }

    return loanDetailsList;
  } catch (error) {
    const isLoggedIn = getLoginState();

    logPageActionToNewRelic("LOAN_DETAILS_API_ERROR", {
      component: "Loan Details",
      pageUrl: typeof window !== "undefined" ? window.location.href : "SSR",
      message: (error as Error).message,
      debugInfo: JSON.stringify({
        isLoggedIn,
      }),
    });
    return [];
  }
};
